export default "__VITE_ASSET__ec7ae3ba__"